import * as React from 'react';
import propz from 'propz';
import { Tournament } from 'Src/models/tournament';
import { Announce } from '../Announce/Announce';
import './AdditionalInfo.scss';

interface Props {
  tournament: Tournament;
}

export const AdditionalInfo = (props: Props) => {
  const { tournament } = props;

  const announcements = propz.get(tournament, ['announcements'], []);
  const isAnnouncementsExist = Array.isArray(announcements) && announcements.length > 0;

  return (
    <section className="bTournamentAdditionalInfo" aria-label="Tournament documents">
      <div className="eAdditionalInfoSection">
        <div className="eAdditionalInfoSectionHeader">
          <h2 className="eAdditionalInfoSectionTitle">Announcements and documents</h2>
          <div className="eAdditionalInfoSectionSubtitle">
            Any updates, organiser notes, or supporting files shared for this tournament will appear here.
          </div>
        </div>

        {isAnnouncementsExist ? (
          <div className="eAdditionalInfoList">
            {announcements.map(item => {
              const itemKey = propz.get(item, ['_id'], Math.random().toString());
              return (
                <div className="eAdditionalInfoItem" key={itemKey}>
                  <Announce item={item} />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="eAdditionalInfoEmptyState">
            <div className="eAdditionalInfoEmptyTitle">No additional information yet</div>
            <div className="eAdditionalInfoEmptyText">
              The organisers have not added any announcements or documents for this tournament so far.
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

AdditionalInfo.displayName = 'AdditionalInfo';

